<template>
  <div class="carousel" v-loading="loading">
    <back />
    <el-form :model="ruleForm" ref="ruleForm" class="ruleForm" label-position="left" label-width="90px">
      <el-row>
        <el-col>
          <el-form-item label="图片">
            <div class="pic_uploader">
              <el-image class="picurl" :src="ruleForm.userPicture" :preview-src-list="[ruleForm.userPicture]">
              </el-image>
            </div>

          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="7">
          <el-form-item label="姓名：">
            <el-input style="width: 250px;" :value="ruleForm.userName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="性别：">
            <el-input style="width: 250px;" :value="ruleForm.gender == 0 ? '女' : ruleForm.gender == 1 ? '男' : '未知'"
              readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="手机号码：">
            <el-input style="width: 250px;" :value="ruleForm.phoneNum || '--'" readonly></el-input>
          </el-form-item>
          <!-- <el-form-item label="出生日期：">
            <el-input style="width: 250px;" :value="ruleForm.gender" readonly></el-input>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="7">
          <el-form-item label="报名时间：">
            <el-input style="width: 250px;" :value="ruleForm.createdTime" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7"></el-col>
        <el-col :span="7"></el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="" label="介绍：">
            <!-- <div class="ql-container ql-snow editor">
              <div class="ql-editor">
                <div v-html="ruleForm.introduce"></div>
              </div>
            </div> -->
            <el-input type="textarea" resize="none" :value="ruleForm.introduce" readonly autosize></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      btnLoading: false,
      ruleForm: {},
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.activityRegisterListInfo, {
          params: {
            id: this.$route.query.id,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.loading = false
            this.ruleForm = res.result
          }

        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
  },
}
</script>
<style scoped lang="scss">
.carousel {
  .pic_uploader {
    border-radius: 10px 10px 10px 10px;
    overflow: hidden;
    width: 100px;
    height: 100px;

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .editor {
    border-radius: 10px;
    min-height: 100px;
  }
}
</style>
